<template>
  <div class="page-component-wrapper">
    <layout-editor-page
      :title="formTitle"
      :isLoading="isLoading"
      :isVisible="isVisible"
    >
      <Form
        class="global-parameters"
        :data="data"
        :model="formModel"
        @updateModelItem="handlerUpdateModelItem"
        @change="handleFormData"
        ref="Form"/>
      <template v-slot:footer>
        <form-controls
          :isSave="true"
          class="form-footer"
          @command="setCommand"/>
      </template>
    </layout-editor-page>
  </div>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'
import { api } from '@/services/api'

export default {
  name: 'EditorLinks',
  mixins: [FormWrapper, FormWrapperAutoSave],
  components: {
    Form: () => import(/* webpackChunkName: 'GlobalParameters' */ './Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  data () {
    return {
      api: 'GlobalParameters/Get/',
      // eslint-disable-next-line
      apiPatch: 'GlobalParameters/Patch/${data.id}',
      isVisible: true,
      currentID: 1
    }
  },
  computed: {
    formTitle () {
      return this.formData.title || this.checkEs6AndRun(this.title)
    }
  },
  methods: {
    formModel () {
      return {
        id: '',
        title: '',
        version: '',
        copyrights: '',
        subTitle: '',
        description: '',
        slogan: '',
        baxBankDetails: '',
        baxTechnicsDetails: '',
        invoiceTermsAndConditions: ''
      }
    },
    handlerRoute () {
      this.requestGetData()
    },
    save () {
      this.$refs.Form.validate()
        .then(_ => {
          this.isLoading = true
          api
            .patch('GlobalParameters/Patch/1', this.$refs.Form.getData())
            .then(response => {
              this.isLoading = false
              this.requestSuccessHandler(response, this.L10n('done'))
            })
            .catch(response => {
              this.isLoading = false
              this.requestErrorHandler(response, this.L10n('error-update-item'))
            })
        })
        .catch(() => this.setQuery('edit'))
    }
  }
}
</script>
